var exports = {
  "kL": "MicupBotTab.module__container___THoyMm",
  "OA": "MicupBotTab.module__fields___THoyMm",
  "vR": "MicupBotTab.module__tabs___THoyMm",
  "nM": "MicupBotTab.module__row___THoyMm",
  "$P": "MicupBotTab.module__search___THoyMm",
  "DD": "MicupBotTab.module__title___THoyMm",
  "R_": "MicupBotTab.module__heading___THoyMm",
  "Nr": "MicupBotTab.module__card___THoyMm",
  "p_": "MicupBotTab.module__list___THoyMm",
  "SU": "MicupBotTab.module__muted___THoyMm",
  "z3": "MicupBotTab.module__error___THoyMm",
};

module.exports = exports;
